import styled from 'styled-components'

import { useGetStatesForCountryQuery } from 'hooks/useQueries'

const SearchableShortcutItem = styled.li``

const SearchableButton = styled.button<{ indent?: boolean }>`
  display: block;
  width: 100%;
  padding: 0.8em;

  font-size: 16px;
  text-align: left;

  color: ${({ theme }) => theme.brand.jungle};
  background-color: white;
  border: none;
  border-radius: 4px;

  &:hover,
  &:focus {
    color: white;
    background-color: ${({ theme }) => theme.brand.jungle};
  }

  ${({ indent }) =>
    indent &&
    `
    padding-left: 30px;
  `}
`

type SearchableCountryProps = {
  countryName: string
  countryCode: string
  onShortcutSelect: (_: { country: string; state?: string }) => any
}

const SearchableCountry = ({
  countryName,
  countryCode,
  onShortcutSelect,
}: SearchableCountryProps) => {
  const { data } = useGetStatesForCountryQuery({
    context: { batching: true },
    variables: {
      country: countryCode as GQL_Countries,
    },
  })

  const states = data?.search?.defaults?.states

  const handleSelectWholeCountry = () =>
    onShortcutSelect({ country: countryCode })

  const buildHandlerSelectState = (stateCode: string) => () =>
    onShortcutSelect({ country: countryCode, state: stateCode })

  return (
    <>
      <SearchableShortcutItem key={`${countryCode}`}>
        <SearchableButton onClick={handleSelectWholeCountry}>
          All {countryName}
        </SearchableButton>
      </SearchableShortcutItem>

      {states?.map(({ id, code, name }) => (
        <SearchableShortcutItem key={`${id}-${code}`}>
          <SearchableButton onClick={buildHandlerSelectState(code)} indent>
            {name}
          </SearchableButton>
        </SearchableShortcutItem>
      ))}
    </>
  )
}

export default SearchableCountry
